import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // ✅ Importar BrowserRouter
import App from "./App";
import "./styles.css";

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <BrowserRouter basename="/"> {/* 🔹 Ajusta "/" si tu app está en subcarpeta */}
      <App />
    </BrowserRouter>
  </StrictMode>
);